<template>
        <button
        :type="Type"
        @click.prevent="ButtonFunction"
        >
        <span id='span-button'></span>
        <i :class="Icon"></i>
        {{Text}}
        </button>
</template>

<script>
    export default {
        props: {
            Type: {
                type: String,
            },
            Text: {
                type: String,
            },
            ButtonFunction: {
                type: Function,
            },
            Icon: {
                type:String
            }
        },
    }
</script>

<style lang="css" scoped>
button {
    background: var(--main-white);
    border: 1px solid var(--main-red-black);
    box-sizing: border-box;
    border-radius: 8px;
    color: var(--main-red-black);
    font-size: 1.1857rem;
    font-weight: bold;
    padding: .6rem 1rem;
    width: 100%;
    
}

  @media (min-width: 1400px) and (max-width: 2600px) {

  }
</style>